import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { trackingEvent } from '../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../analytics/utils';
import { isColumnVisibleByDefault } from '../../../../utils/partialPermissionUtils';
import renderCompanies from './renderCompanies';
import { setupGlobalHandlers } from './utils';
import { showSubcontractModal } from '../../../../redux/slices/uiSlice';
setupGlobalHandlers();

const subcontractIdCol = (gantt, t, fieldNoPermission) => {
  const columnName = 'subcontractId';

  const columnDefinition = {
    name: columnName,
    label: 'Subcontrato',
    data_type: 'array/string',
    visible: true,
    hide: !isColumnVisibleByDefault(columnName),
    span: 2,
    offset: 0,
    align: 'center',
    mode: 'single',
    width: 180,
    groupable: false,
    from_values: 'subContracts',
    groupable_switch: ['1 → N', 'N → 1'],
    orderable: false,
    orderable_switch: ['1 → N', 'N → 1'],
    filterable: true,
    avoid_translate: true,
    resize: true,
    template: (task) => {
      return renderCompanies({
        column: columnDefinition,
        gantt,
        t,
        onlyRead: fieldNoPermission,
        task,
        mainObject: {},
        customMainClassName: '',
        subs: gantt.subContracts,
        callbackOnClickCreate: () => {
          trackingEvent(
            'activity_subcontract_creation_initiated',
            {
              ...getBasicAmplitudEventProperties(),
              activity_id: task?.id,
              activity_name: task?.text,
              activity_index: task?.correlative_id
            },
            AMPLITUDE_SERVICE
          );
          gantt.setVisibleFormSubcontract(true);
          gantt.toHardAssignSubcontract = task.id;
          showSubcontractModal();
        }
      });
    },
    templateExportable: (task) => {
      const gantt = window.to_use_react_gantt;
      const column = 'subcontractId';
      if (!gantt) {
        return;
      }

      const statusObject = gantt.subContracts?.find(
        (e) => e.id === task[column]
      );
      if (!statusObject) {
        return;
      }

      const { name: companyName, color: companyColor } = statusObject;
      const companyIcon = (
        <div
          className="company-column-template__icon"
          style={{ background: companyColor }}></div>
      );
      const companyTemplate = (
        <div className="company-column-template subcontract-border cut-text-and-dot">
          {companyIcon}
          <p className="company-column-template__text">{companyName}</p>
        </div>
      );

      const companyTemplateString =
        ReactDOMServer.renderToStaticMarkup(companyTemplate);
      return companyTemplateString;
    }
  };

  return columnDefinition;
};

export default subcontractIdCol;
